import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-overflow-x-scroll" }
const _hoisted_2 = {
  key: 0,
  class: "tw-mb-1 tw-block tw-text-xs"
}
const _hoisted_3 = { class: "tw-flex tw-w-fit tw-min-w-full tw-gap-1 tw-rounded-md tw-border tw-p-1 tw-font-medium" }
const _hoisted_4 = ["disabled", "data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipPopup = _resolveComponent("TooltipPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button) => {
        return (_openBlock(), _createBlock(_component_TooltipPopup, {
          key: button.id,
          position: _ctx.tooltipPosition,
          tooltipClasses: "!tw-w-56",
          class: _normalizeClass(["tw-min-w-[80px] tw-flex-1 tw-cursor-pointer tw-rounded-sm tw-p-2 tw-text-center tw-text-xs hover:tw-bg-slate-100 dark:hover:tw-bg-slate-900", {
          '!tw-bg-black !tw-text-white': _ctx.isActive(button),
          '!tw-bg-slate-500 hover:!tw-bg-slate-500': _ctx.isActive(button) && (_ctx.isPickerDisabled || button.disabled),
          '!tw-cursor-not-allowed': _ctx.isPickerDisabled || button.disabled
        }]),
          onClick: ($event: any) => (_ctx.onClickPickerButton(button))
        }, _createSlots({
          trigger: _withCtx(() => [
            _createElementVNode("button", {
              disabled: _ctx.isPickerDisabled || button.disabled,
              "data-testid": button.text
            }, [
              _createTextVNode(_toDisplayString(button.text) + " ", 1),
              (button?.label)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(_ctx.labelCss)
                  }, _toDisplayString(button.label), 3))
                : _createCommentVNode("", true)
            ], 8, _hoisted_4)
          ]),
          _: 2
        }, [
          (_ctx.pickerDisabledReason)
            ? {
                name: "content",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pickerDisabledReason), 1)
                ]),
                key: "0"
              }
            : (button.disabled)
              ? {
                  name: "content",
                  fn: _withCtx(() => [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This feature is not enabled for your organization. "),
                      _createElementVNode("button", {
                        class: "tw-underline",
                        onClick: ($event: any) => (
                _ctx.$emit('handleContactGoldcast', button.contactGoldcastText ? button.contactGoldcastText : button.text)
              )
                      }, " Contact Goldcast ", 8, ["onClick"]),
                      _createTextVNode(" to get access. ")
                    ])
                  ]),
                  key: "1"
                }
              : undefined
        ]), 1032, ["position", "class", "onClick"]))
      }), 128))
    ])
  ]))
}